import React from 'react'

const Textarea = (props) => {
  const {
    id,
    name,
    formSet,
    value,
    onChange,
    formRef = null,
    errors = {},
    icon = null,
    rows = 4,
    inputLabelsMap,
    errorsMap
  } = props

  return (
    <div className={`form-input ${!icon && 'without-icon' }`}>
      <textarea
        id={id}
        className="input textarea"
        name={`${formSet}[${name}]`}
        rows={rows}
        value={value}
        onChange={e => onChange({ [name]: e.target.value })}
        ref={formRef}
      />

      <label
        className={icon ? `label label-icon ${icon}` : `label`}
        htmlFor={id}
      >
        {!value && <span className="label-content">{inputLabelsMap[name]}</span>}
      </label>

      {errors && errors[name] && (
        <span className="input-error">{errorsMap[errors[name].type]}</span>
      )}
    </div>
  )
}

export default Textarea
